module.exports = __webpack_public_path__ + "static/media/ps.42f2391e.svg";